import React from 'react'
import Nav from '../components/Nav'
import { useNavigate } from 'react-router-dom'



export default function Home() {
  const navigate = useNavigate()
  return (
    <div className=' w-full h-screen bg-[#1E2029] '>
      <Nav/>
      <div className=' w-full min-h-[90vh] flex flex-col justify-center items-center px-[2em]'>
        <div className='w-full md:w-[50%] h-[10em] justify-between flex items-center  '>
          <button className='min-w-[40%] p-[.9em] bg-[#9A6AFF] rounded-[1.4em] hover:bg-[#E3E3E3]' onClick={()=>{navigate("/adminLogin")}}>
          <p className=' font-medium text-lg'>  Admin</p>
          </button>
          <button className='min-w-[40%] p-[.9em] bg-[#9A6AFF] rounded-[1.4em] hover:bg-[#E3E3E3]'  onClick={()=>{navigate("/employeeSignin")}}>
          <p className=' font-medium text-lg'>  Employee</p>
          </button>

        </div>


      </div>


    </div>
  )
}
